export { HeadingPersuasion } from "./HeadingPersuasion";

